"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewPage = ReviewPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const js_1 = require("@mdi/js");
const next_intl_1 = require("next-intl");
const client_2 = require("../../client/index.js");
const embed_footer_1 = require("../embed-footer.js");
const layout_1 = require("../layout.js");
const review_navigation_card_1 = require("../review-navigation-card.js");
const review_question_card_1 = require("../review-question-card.js");
function ReviewPage({ embedContext, homepageHref, privacyHref, questions, answers, calculator, onNextClick, onPreviousClick, onCloseClick }) {
    const t = (0, next_intl_1.useTranslations)("koa.pages");
    const handleAgreeChange = (questionId, agree) => {
        if (agree) {
            answers.setAnswer({
                questionId,
                answer: true,
            });
        }
        else {
            answers.setAnswer({
                questionId,
                answer: undefined,
            });
        }
    };
    const handleDisagreeChange = (questionId, disagree) => {
        if (disagree) {
            answers.setAnswer({
                questionId,
                answer: false,
            });
        }
        else {
            answers.setAnswer({
                questionId,
                answer: undefined,
            });
        }
    };
    const handleImportantChange = (questionId, isImportant) => {
        answers.setAnswer({
            questionId,
            isImportant,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(layout_1.Layout, { children: [(0, jsx_runtime_1.jsx)(layout_1.Layout.Header, { children: (0, jsx_runtime_1.jsx)(client_2.AppHeader, { calculator: calculator, children: (0, jsx_runtime_1.jsx)(client_2.AppHeader.Right, { children: (0, jsx_runtime_1.jsx)(client_2.HideOnEmbed, { children: (0, jsx_runtime_1.jsx)(client_1.Button, { variant: "round", color: "neutral", size: "small", "aria-label": t("common.close"), onClick: onCloseClick, children: (0, jsx_runtime_1.jsx)(client_1.Icon, { icon: js_1.mdiClose, size: "medium", decorative: true }) }) }) }) }) }), (0, jsx_runtime_1.jsxs)(layout_1.Layout.Content, { children: [(0, jsx_runtime_1.jsx)("div", { className: "koa:mb-4", children: (0, jsx_runtime_1.jsxs)(client_1.Button, { variant: "pill", color: "neutral", onClick: onPreviousClick, children: [(0, jsx_runtime_1.jsx)(client_1.Icon, { icon: js_1.mdiArrowLeft, size: "small", decorative: true }), t("review.back")] }) }), (0, jsx_runtime_1.jsx)("h3", { className: "koa:font-display koa:font-bold koa:text-display koa:tracking-tight koa:text-text koa:mb-2 koa:sm:mb-3", children: t("review.title") }), (0, jsx_runtime_1.jsx)("p", { className: "koa:mb-5 koa:sm:mb-6 koa:max-w-prose koa:text-text-muted koa:leading-[1.5]", children: t("review.description") }), (0, jsx_runtime_1.jsx)("div", { className: "koa:grid koa:gap-2 koa:sm:gap-3", children: questions.questions.map((question) => {
                            const answer = answers.answers.find((a) => a.answer?.questionId === question.id) || {
                                answer: undefined,
                                setAnswer: answers.setAnswer,
                            };
                            return ((0, jsx_runtime_1.jsx)(review_question_card_1.ReviewQuestionCard, { question: question, answer: answer, onAgreeChange: (agree) => handleAgreeChange(question.id, agree), onDisagreeChange: (disagree) => handleDisagreeChange(question.id, disagree), onImportantChange: (isImportant) => handleImportantChange(question.id, isImportant) }, question.id));
                        }) })] }), (0, jsx_runtime_1.jsx)(layout_1.Layout.BottomNavigation, { children: (0, jsx_runtime_1.jsx)(review_navigation_card_1.ReviewNavigationCard, { onNextClick: onNextClick }) }), (0, jsx_runtime_1.jsx)(layout_1.Layout.Footer, { children: embedContext.isEmbed && (0, jsx_runtime_1.jsx)(embed_footer_1.EmbedFooter, { attribution: embedContext.config?.attribution, homepageHref: homepageHref, privacyHref: privacyHref }) })] }));
}
